export default "__VITE_ASSET__Dsm4Ds2H__"